/* ============================================
   KEIYTEX THEME – JAVASCRIPT
   ============================================ */

// ── Hero Slider ──────────────────────────────
const slides  = document.querySelectorAll('.hero-slide');
const dots    = document.querySelectorAll('.dot');
const prevBtn = document.getElementById('heroPrev');
const nextBtn = document.getElementById('heroNext');
let current   = 0;
let autoTimer = null;

function goTo(idx) {
  slides[current].classList.remove('active');
  dots[current].classList.remove('active');
  current = (idx + slides.length) % slides.length;
  slides[current].classList.add('active');
  dots[current].classList.add('active');
}

function startAuto() {
  autoTimer = setInterval(() => goTo(current + 1), 5500);
}

function resetAuto() {
  clearInterval(autoTimer);
  startAuto();
}

if (slides.length) {
  prevBtn.addEventListener('click', () => { goTo(current - 1); resetAuto(); });
  nextBtn.addEventListener('click', () => { goTo(current + 1); resetAuto(); });
  dots.forEach(d => d.addEventListener('click', () => { goTo(+d.dataset.slide); resetAuto(); }));
  startAuto();

  // Touch / swipe support
  let touchStartX = 0;
  const heroEl = document.getElementById('heroSlider');
  heroEl.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
  heroEl.addEventListener('touchend', e => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) { goTo(diff > 0 ? current + 1 : current - 1); resetAuto(); }
  });
}

// ── Slide 1 color swatches ────────────────────
function selectSlide1Color(btn) {
  var imgUrl = btn.dataset.img;
  var slide  = document.getElementById('slide1');
  if (slide && imgUrl) {
    slide.style.backgroundImage = "url('" + imgUrl + "')";
    var lcpImg = document.getElementById('slide1LcpImg');
    if (lcpImg) lcpImg.src = imgUrl;
  }
  document.querySelectorAll('.color-swatch').forEach(function(s) {
    s.classList.remove('active');
  });
  btn.classList.add('active');
}

// ── Sticky header shadow ──────────────────────
const header = document.getElementById('header');
window.addEventListener('scroll', () => {
  header.classList.toggle('scrolled', window.scrollY > 20);
}, { passive: true });

// ── Mobile nav ───────────────────────────────
const burger    = document.getElementById('burger');
const mobileNav = document.getElementById('mobileNav');
const overlay   = document.getElementById('overlay');

function openMobile() {
  mobileNav.classList.add('open');
  overlay.classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeMobile() {
  mobileNav.classList.remove('open');
  overlay.classList.remove('active');
  document.body.style.overflow = '';
}

burger.addEventListener('click', () => {
  mobileNav.classList.contains('open') ? closeMobile() : openMobile();
});
overlay.addEventListener('click', closeMobile);

// ── Wishlist hearts ───────────────────────────
document.querySelectorAll('.product-wishlist').forEach(btn => {
  btn.addEventListener('click', e => {
    e.stopPropagation();
    const svg    = btn.querySelector('path');
    const active = btn.classList.toggle('wishlisted');
    if (svg) svg.setAttribute('fill',   active ? '#c0392b' : 'none');
    if (svg) svg.setAttribute('stroke', active ? '#c0392b' : 'currentColor');
  });
});

// ── Newsletter form ───────────────────────────
document.querySelectorAll('.newsletter-form').forEach(form => {
  form.addEventListener('submit', e => {
    e.preventDefault();
    const input = form.querySelector('input[type="email"]');
    if (input && input.value.includes('@')) {
      const btn = form.querySelector('button');
      btn.textContent        = '✓';
      btn.style.background   = '#27ae60';
      btn.style.borderColor  = '#27ae60';
      btn.style.color        = '#fff';
      input.value            = '';
      input.placeholder      = 'Danke! Du erhältst eine Bestätigung.';
      setTimeout(() => {
        btn.textContent       = '→';
        btn.style.background  = '';
        btn.style.borderColor = '';
        btn.style.color       = '';
        input.placeholder     = 'Deine E-Mail-Adresse';
      }, 3500);
    }
  });
});

// ── Scroll reveal ─────────────────────────────
const revealEls = document.querySelectorAll(
  '.product-card, .cat-tile, .editorial-tile, .feature-item'
);

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.12 });

revealEls.forEach((el, i) => {
  el.style.opacity   = '0';
  el.style.transform = 'translateY(24px)';
  el.style.transition = `opacity 0.5s ease ${(i % 4) * 80}ms, transform 0.5s ease ${(i % 4) * 80}ms`;
  observer.observe(el);
});

// ── Lewskaps Produkt-Slider ───────────────────
document.querySelectorAll('.lk-slider').forEach(slider => {
  const track = slider.querySelector('.lk-track');
  const prev  = slider.querySelector('.lk-prev');
  const next  = slider.querySelector('.lk-next');
  const bar   = slider.querySelector('.lk-progress span');
  if (!track) return;

  const step = () => {
    const card = track.querySelector('.lk-card');
    return card ? card.offsetWidth + 14 : track.clientWidth * 0.4;
  };
  if (next) next.addEventListener('click', () => track.scrollBy({ left:  step(), behavior: 'smooth' }));
  if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));

  if (bar) {
    track.addEventListener('scroll', () => {
      const max = track.scrollWidth - track.clientWidth;
      const pct = max > 0 ? track.scrollLeft / max : 0;
      bar.style.transform = 'translateX(' + (pct * 200) + '%)';
    }, { passive: true });
  }
});

// ── Lewskaps Typewriter (CTA-Banner) ───────────
// Tippt Überschrift + Text Zeichen für Zeichen, sobald der Banner ins
// Sichtfeld scrollt. Danach bleibt der Text stehen. Progressive Enhancement:
// ohne JS steht der volle Text sofort da; prefers-reduced-motion überspringt.
document.querySelectorAll('[data-lk-type-banner]').forEach(banner => {
  const parts = [...banner.querySelectorAll('.lk-type')].map(el => {
    const full = el.textContent;
    el.textContent = '';
    el.classList.add('lk-type--pending');
    return { el, full };
  });
  if (!parts.length) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const typeAll = () => {
    if (reduce) {
      parts.forEach(p => { p.el.textContent = p.full; p.el.classList.remove('lk-type--pending'); });
      return;
    }
    let i = 0;
    const typePart = () => {
      if (i >= parts.length) return;
      const { el, full } = parts[i];
      el.classList.remove('lk-type--pending');
      el.classList.add('lk-type--active');
      const speed = full.length > 60 ? 16 : 45;   // langer Absatz tippt zügiger
      let c = 0;
      const timer = setInterval(() => {
        el.textContent = full.slice(0, ++c);
        if (c >= full.length) {
          clearInterval(timer);
          el.classList.remove('lk-type--active');
          i++;
          setTimeout(typePart, 260);              // kurze Pause zwischen den Blöcken
        }
      }, speed);
    };
    typePart();
  };

  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) { io.unobserve(banner); typeAll(); }
    });
  }, { threshold: 0.35 });
  io.observe(banner);
});
